exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2izfhFaB,._3xPCAvar{margin:0;padding:0;display:inline-block}", ""]);

// exports
exports.locals = {
	"focus-lock-style": "_2izfhFaB",
	"wrapper-style": "_3xPCAvar"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/focuslock/styles.less
// module id = 1079
// module chunks = 1 3